import { render, staticRenderFns } from "./textArea.vue?vue&type=template&id=54201da0&scoped=true&"
import script from "./textArea.vue?vue&type=script&lang=js&"
export * from "./textArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54201da0",
  null
  
)

export default component.exports